<template>
    <div class="flex">
        <div class="w-full xl:w-2/3 lg:w-2/3 md:w-full sm:w-full">
            <div class="flex">
                <div class="w-full xl:w-1/3 lg:w-1/3 p-0 mr-0 card-title">Afdelingen</div>
                <div class="w-full xl:w-1/3 lg:w-1/2 text-muted offset-lg-1 offset-xl-3 text-right" style="font-size: 12px;">
                    <label for="open_add_department" class="hoverObject">Afdeling toevoegen</label>
                    <button id="open_add_department" data-toggle="modal" data-target="#add_department" class="rounded-circle btn-secondary ml-1" style="border: none;"><i class="fas fa-plus px-1"></i></button>
                    <company-add-department v-on:added-department="reloadDepartments" :changedDepartments="changedDepartments"></company-add-department>
                </div>
            </div>
            <div class="accordion p-0 mt-2 w-full flex" id="accordionFirst" style="height: 400px; overflow: auto;">
                <div class="card w-full xl:w-1/3 lg:w-1/2 p-0" v-for="(department, name) in departments" v-bind:key="department.id">
                    <div class="card-header department-header pl-2" :id="`heading-${department.id}`" style="background-color: white; border-bottom: 0px; padding-left: 0px;">
                        <div class="w-full">
                            <h2 class="mb-0">
                                <button class="btn btn-block text-left font-weight-bold p-0" type="button" aria-expanded="true" @click="chooseDepartment(department.id)">
                                    <div class="flex">
                                        <div class="xl:w-3/4 w-5/6 selected-department">
                                            <input type='hidden' :value="department.id" />
                                            <span class="card-title pl-0" style="font-size: 15px;">{{ name }}</span>
                                        </div>
                                        <div class="xl:w-1/4 lg:w-1/12 pl-2">
                                            <i class="fas fa-times" @click="areYouSureModal(department.id, name)"></i>
                                        </div>
                                    </div>
                                </button>
                            </h2>
                        </div>
                    </div>
                    <div v-for="(subDepartment, name) in department.children" v-bind:key="subDepartment.id" id="collapseFirst" class="collapse show" :aria-labelledby="`heading-${department.id}`" data-parent="#accordionFirst">
                        <company-department :offset="10" :data="subDepartment" :name="name" v-on:change-department="changeDepartment" v-on:deleted-department="areYouSureModal" :selectedDepartment="selectedDepartment"></company-department>
                    </div>
                </div>
            </div>
        </div>
        <div class="xl:w-1/3 lg:w-1/3 w-full setting-border">
            <div class="container pr-0 pt-3">
                <div class="flex flex-wrap">
                    <div class="card-title">Bewerken</div>
                    <div class="flex w-full">
                        <small>Hieronder zijn de medewerkers zichtbaar van de afdeling. Dit toont ook de werknemers van subafdelingen die onder de gekozen afdeling vallen.</small>
                    </div>
                </div>
                <company-employees :selectedDepartment="selectedDepartment"></company-employees>
            </div>
        </div>
        <div class="modal fade" id="delete_department" tabindex="-1" role="dialog" aria-labelledby="delete_department_label" data-backdrop="static" data-keyboard="false" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: 0px;">
                        <button type="button" class="close" aria-label="Close" data-dismiss="modal" @click="closeModal()">
                            <i class='fas fa-times text-muted'></i>
                        </button>
                    </div>
                    <div class="modal-body container">
                        <div class="form-group">
                            <h4>Weet je zeker dat je deze afdeling wilt verwijderen?</h4>
                            <label for="department_name" class="font-weight-bold">Afdeling: <span id="delete_department_name" class="font-weight-normal font-italic"></span></label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="deleteDepartment">Verwijderen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                departments: [],
                selectedDepartment: null,
                deleting: false,
                changedDepartments: true,
                toDelete: 0,
            }
        },
        mounted() {
            this.getDepartments();
        },
        methods: {
            /**
             *
             * Get data
             *
             */
            getDepartments() {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `/companies/departments`,
                    success: this.saveDepartments,
                });
            },
            reloadDepartments() {
                this.getDepartments();
                this.changedDepartments = !this.changedDepartments;
            },
            /**
             *
             * Events
             *
             */
            saveDepartments(event) {
                this.departments = event.departments;
            },
            changeDepartment(departmentID) {
                if (!this.deleting) {
                    this.toggleSelected(departmentID)
                    this.toggleSelected(this.selectedDepartment)
                    this.selectedDepartment = departmentID;

                    this.$emit('change-department', departmentID);
                }

                this.deleting = false;
            },
            chooseDepartment(departmentID) {
                this.changeDepartment(departmentID);
            },
            deleteDepartment() {
                if (this.selectedDepartment == this.toDelete) this.selectedDepartment = null;
                this.deleting = true;

                // Remove department from database
                $.ajax({
                    type : 'DELETE',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `delete-department`,
                    data:{
                        id: this.toDelete,
                    },
                    success: this.reloadDepartments,
                });

                $('#delete_department').modal('hide');
                this.toDelete = 0;
            },
            /**
             *
             * Change views
             *
             */
            toggleSelected(departmentID) {
                $(`#heading-${departmentID}`).toggleClass('selected-department-header');
                if ($(`#heading-${departmentID}`).hasClass('selected-department-header')) {
                    $(`#heading-${departmentID}`).css("padding-left", "-=5");
                } else {
                    $(`#heading-${departmentID}`).css("padding-left", "+=5");
                }
            },
            closeModal() {
                $('#delete_department').modal('hide');
            },
            areYouSureModal(id, name) {
                this.toDelete = id;
                $('#delete_department_name').html(name);
                $('#delete_department').modal('show');
            }
        },
    }
</script>
